module.exports = __webpack_public_path__ + "img/active-bg.fac16743.png";